import {PageContent} from '@/components/ui/page-atoms/PageAtoms'
import styled from 'styled-components'

export const StyledProjectsRoute = styled(PageContent)`
    width: 100%;
    height: 100%;
`
